<template>
  <div>
    <section class="con2">
      <div class="container inner">
        <p
          class="text0"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="linear"
        >
          Brand Story
        </p>
        <p
          class="text1"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="linear"
        >
          명상리더십 소사이어티 센터원을 소개합니다.
        </p>
        <p
          class="text2"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="linear"
        >
          기업에 명상 리더십 훈련을 제공하여 리더들의 변화를 돕는
          플랫폼입니다.<br />다양한 명상 기법과 학습 경험을 조합하여 최고 수준의
          교육과 콘텐츠를 제공합니다.
        </p>

        <div
          class="slider-wrap"
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-easing="linear"
        >
          <VueSlickCarousel v-bind="settings1">
            <div class="item">
              <img
                src="@/assets/img/centerone/con2/slide1-m.png"
                alt="icon"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con2/slide1-pc.png"
                alt="icon"
                class="img-pc"
              />
              <p>명상 리더십</p>
            </div>
            <div class="item">
              <img
                src="@/assets/img/centerone/con2/slide2-m.png"
                alt="icon"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con2/slide2-pc.png"
                alt="icon"
                class="img-pc"
              />
              <p>멤버십</p>
            </div>
            <div class="item">
              <img
                src="@/assets/img/centerone/con2/slide3-m.png"
                alt="icon"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con2/slide3-pc.png"
                alt="icon"
                class="img-pc"
              />
              <p>ESG</p>
            </div>
            <div class="item">
              <img
                src="@/assets/img/centerone/con2/slide4-m.png"
                alt="icon"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con2/slide4-pc.png"
                alt="icon"
                class="img-pc"
              />
              <p>특강</p>
            </div>
            <div class="item">
              <img
                src="@/assets/img/centerone/con2/slide5-m.png"
                alt="icon"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con2/slide5-pc.png"
                alt="icon"
                class="img-pc"
              />
              <p>워크숍</p>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  components: { VueSlickCarousel },

  data() {
    return {
      settings1: {
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        swipe: false,
        swipeToSlide: false,
        pauseOnHover: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              variableWidth: false,
            },
          },
        ],
      },
    };
  },

  mounted() {
    AOS.init();
  },
};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

// con2
.con2 {
  padding: 70px 0;
  background-color: #f7f2ec;
  overflow: hidden;

  @media screen and (min-width: 1200px) {
    padding: 150px 0;
  }

  .inner {
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
    }

    .text0 {
      font-size: 20px;
      font-weight: 700;
      color: #998465;
      margin-bottom: 20px;

      @media screen and (min-width: 1200px) {
        font-size: 24px;
      }
    }

    .text1 {
      font-size: 34px;
      font-weight: 700;
      color: #000;
      margin-bottom: 30px;

      @media screen and (min-width: 1200px) {
        font-size: 64px;
      }
    }

    .text2 {
      color: #3e3e3e;
      margin-bottom: 70px;

      @media screen and (min-width: 1200px) {
        font-size: 24px;
        margin-bottom: 90px;
      }
    }

    .slider-wrap {
      :deep(.slick-slider) {
        .slick-list {
          border-radius: 10px;

          @media screen and (min-width: 1200px) {
            width: 100dvw !important;
            border-radius: 20px;
          }

          .slick-track {
            display: flex;

            .slick-slide {
              margin: 0 10px;
              @media screen and (min-width: 1200px) {
                margin: 0 30px;
              }

              > div {
                .item {
                  position: relative;
                  border-radius: 10px;
                  overflow: hidden;

                  @media screen and (min-width: 1200px) {
                    border-radius: 20px;
                  }

                  img {
                    @media screen and (min-width: 1200px) {
                      max-width: 1200px;
                    }

                    &.img-m {
                      @media screen and (min-width: 1200px) {
                        display: none;
                      }
                    }

                    &.img-pc {
                      display: none;

                      @media screen and (min-width: 1200px) {
                        display: block;
                      }
                    }
                  }

                  p {
                    font-size: 20px;
                    font-weight: 700;
                    color: #fff;
                    position: absolute;
                    right: 20px;
                    bottom: 20px;

                    @media screen and (min-width: 1200px) {
                      font-size: 40px;
                      right: 60px;
                      bottom: 60px;
                    }
                  }
                }
              }
            }
          }
        }

        .slick-prev {
          top: -25px;
          transform: translate(0);
          left: unset;
          right: 35px;
          width: 8px;
          height: 15px;
          background: url(~@/assets/img/centerone/con2/prev.png) no-repeat
            center / contain;

          &::before {
            display: none;
          }

          @media screen and (min-width: 1200px) {
            top: -115px;
            right: 37px;
            width: 12px;
            height: 22px;
          }
        }

        .slick-next {
          top: -25px;
          transform: translate(0);
          left: unset;
          right: 10px;
          width: 8px;
          height: 15px;
          background: url(~@/assets/img/centerone/con2/next.png) no-repeat
            center / contain;

          &::before {
            display: none;
          }

          @media screen and (min-width: 1200px) {
            top: -115px;
            width: 12px;
            height: 22px;
          }
        }

        .slick-dots {
          display: flex !important;
          justify-content: flex-start;
          gap: 10px;
          position: relative !important;
          left: 10px;
          bottom: -18px;

          @media screen and (min-width: 1050px) {
            position: absolute !important;
            left: 0;
            bottom: -40px;
          }

          li {
            width: 8px;
            height: 8px;
            margin: 0;

            @media screen and (min-width: 1050px) {
              width: 10px;
              height: 10px;
            }

            button {
              position: relative;
              font-size: unset;
              padding: 0;
              width: 10px;
              height: 10px;
              display: flex;
              align-items: center;
              justify-content: center;

              &::before {
                content: "";
                font-size: 0;
                width: 10px;
                height: 10px;
                line-height: 0;
                background-color: #fff;
                border-radius: 100%;
                opacity: 1;
              }
            }

            &.slick-active {
              button {
                position: relative;
                font-size: unset;
                padding: 0;
                width: 10px;
                height: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                &::before {
                  content: "";
                  font-size: 0;
                  width: 10px;
                  height: 10px;
                  line-height: 0;
                  background-color: #998465;
                  border-radius: 100%;
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
